/* Ombrail newsletter pop-up (v24). Owned by the Newsletter session. No dependency. */
(() => {
  const root = document.querySelector('[data-onp]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const KEY = 'ombrail.newsletter.v1';
  const DAY = 864e5;
  const store = name => { try { const s = window[name]; s.setItem('__onp', '1'); s.removeItem('__onp'); return s; } catch (e) { return null; } };
  const ls = store('localStorage');
  const ss = store('sessionStorage');
  const read = () => { try { return JSON.parse(ls.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const save = data => { try { ls.setItem(KEY, JSON.stringify(Object.assign(read(), data, { at: Date.now() }))); } catch (e) {} };
  const sget = k => { try { return ss.getItem(k); } catch (e) { return null; } };
  const sset = (k, v) => { try { ss.setItem(k, v); } catch (e) {} };

  const status = (root.querySelector('[data-onp-status]') || {}).dataset?.onpStatus || '';
  const fromPopup = /OmbrailPopupNewsletter/.test(location.hash) || sget('ombrail.nl.sent') === '1';
  try { ss && ss.removeItem('ombrail.nl.sent'); } catch (e) {}
  const preview = /[?&]onp_preview=1/.test(location.search);
  const phone = matchMedia('(max-width: 760px)');
  const isProduct = root.dataset.page === 'product';

  let dialog, bar, lastFocus, cssReady;

  // Page scroll is locked while the offer is open. The scrollbar gutter stays reserved: nothing shifts sideways.
  const lock = on => document.documentElement.classList.toggle('onp-lock', on);

  const loadCss = () => cssReady || (cssReady = new Promise(done => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = root.dataset.css;
    link.onload = link.onerror = () => done();
    document.head.append(link);
    setTimeout(done, 4000);
  }));

  const build = () => {
    if (dialog) return;
    const frag = root.querySelector('template').content.cloneNode(true);
    dialog = frag.querySelector('.onp');
    bar = frag.querySelector('.onp-bar');
    bar.hidden = true;
    document.body.append(dialog, bar);
    // Logo on the gift card: reuse the footer's wordmark instead of shipping a second copy in every page.
    const mark = dialog.querySelector('[data-onp-mark]');
    const logo = document.querySelector('.o-foot__voucher-mark svg, .o-foot__brand svg');
    if (mark && logo) mark.replaceChildren(logo.cloneNode(true));
    if (status === 'success') {
      const mask = dialog.querySelector('[data-onp-mask]');
      if (mask) mask.textContent = root.dataset.code;
    }
    dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('close', () => { if (!dialog.open) lock(false); });
    dialog.addEventListener('click', event => { if (event.target === dialog) dismiss(); });
    dialog.addEventListener('keydown', trapFocus);
    document.addEventListener('click', event => {
      if (event.target.closest('[data-onp-dismiss]')) dismiss();
      else if (event.target.closest('[data-onp-open]')) { hideBar(false); openDialog(true); }
    });
    const form = dialog.querySelector('form');
    if (form && form.querySelector('input[type=email]')) {
      form.addEventListener('submit', () => {
        sset('ombrail.nl.sent', '1');
        // Shopify may show an hCaptcha challenge outside the form. A modal dialog would make it unreachable,
        // so the dialog becomes non-modal (same look) while the form is sent.
        if (dialog.open && dialog.matches(':modal')) {
          dialog.close();
          dialog.classList.add('is-sending');
          dialog.show();
        }
        const button = form.querySelector('[type=submit]');
        if (button) {
          const label = button.textContent;
          button.textContent = 'Sending…';
          button.setAttribute('aria-busy', 'true');
          setTimeout(() => { button.textContent = label; button.removeAttribute('aria-busy'); }, 6000);
        }
      });
    }
    const copy = dialog.querySelector('[data-onp-copy]');
    if (copy) copy.addEventListener('click', async () => {
      let done = false;
      try { await navigator.clipboard.writeText(copy.dataset.onpCopy); done = true; } catch (e) {
        const value = dialog.querySelector('.onp__code-value');
        if (value) { const range = document.createRange(); range.selectNodeContents(value); const sel = getSelection(); sel.removeAllRanges(); sel.addRange(range); done = document.execCommand && document.execCommand('copy'); }
      }
      if (done) { copy.textContent = 'Copied'; setTimeout(() => { copy.textContent = 'Copy code'; }, 2200); }
    });
    const apply = dialog.querySelector('[data-onp-apply]');
    if (apply) apply.addEventListener('click', async () => {
      const code = encodeURIComponent(root.dataset.code);
      const live = dialog.querySelector('[data-onp-live]');
      apply.disabled = true;
      try {
        const res = await fetch('/discount/' + code, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.status);
        apply.textContent = 'Applied';
        if (live) live.textContent = 'The code is saved for checkout. It applies to orders from S$1,000.';
      } catch (e) {
        location.href = '/discount/' + code + '?redirect=' + encodeURIComponent(location.pathname + location.search.replace(/[?&]customer_posted=true/, ''));
      }
    });
  };

  const focusables = () => [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length);
  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  async function openDialog(userAsked) {
    build();
    await loadCss();
    if (dialog.open) return;
    lastFocus = document.activeElement;
    dialog.classList.remove('is-closing', 'is-sending');
    dialog.showModal();
    lock(true);
    // Focus the field only when the visitor asked for the form (or came back to it); otherwise the dialog itself.
    const field = dialog.querySelector('[aria-invalid=true]') || (userAsked ? dialog.querySelector('input[type=email]') : null);
    if (field) field.focus();
    else { dialog.setAttribute('tabindex', '-1'); dialog.focus(); }
  }

  const animateOut = (el, done) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !el.getAnimations) { done(); return; }
    el.classList.add('is-closing');
    const target = el.matches('.onp') ? el.querySelector('.onp__card') : el;
    const anims = target.getAnimations();
    if (!anims.length) { done(); return; }
    Promise.all(anims.map(a => a.finished.catch(() => {}))).then(done);
    setTimeout(done, 400);
  };

  function closeDialog() {
    if (!dialog || !dialog.open || dialog.classList.contains('is-closing')) return;
    animateOut(dialog, () => {
      if (!dialog.open) return;
      dialog.close();
      lock(false);
      dialog.classList.remove('is-closing');
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    });
  }

  function hideBar(animate) {
    if (!bar || bar.hidden) return;
    const done = () => { bar.hidden = true; bar.classList.remove('is-closing'); };
    animate ? animateOut(bar, done) : done();
  }

  function dismiss() {
    if (status !== 'success' && !preview) save({ state: 'dismissed' });
    closeDialog();
    hideBar(true);
  }

  async function showOffer() {
    sset('ombrail.nl.shown', '1');
    const seen = read();
    if (!preview) save({ state: 'seen', n: (seen.state === 'seen' ? seen.n || 0 : 0) + 1 });
    if (phone.matches) {
      build();
      await loadCss();
      bar.hidden = false;
    } else {
      openDialog(false);
    }
  }

  // --- After a post from this pop-up (native form, so Shopify's spam protection applies) ---
  if (status === 'success') {
    save({ state: 'subscribed' });
    if (fromPopup) openDialog(false);
    return;
  }
  if (document.querySelector('#FooterNewsletter [data-o-copy], #FooterNewsletter .o-foot__code')) { save({ state: 'subscribed' }); return; }
  if (status === 'error' && fromPopup) { openDialog(true); return; }
  if (preview) { showOffer(); return; }

  // --- Eligibility ---
  if (!ls || !ss) return; // Without storage we could not remember a "no": never show.
  const pageViews = (parseInt(sget('ombrail.nl.pv'), 10) || 0) + 1;
  sset('ombrail.nl.pv', String(pageViews));
  const st = read();
  const age = Date.now() - (st.at || 0);
  if (st.state === 'subscribed' && age < 365 * DAY) return;
  if (st.state === 'dismissed' && age < 30 * DAY) return;
  if (st.state === 'seen' && (st.n || 0) >= 2 && age < 30 * DAY) return;
  if (sget('ombrail.nl.shown')) return;
  if (phone.matches && (isProduct || pageViews < 2)) return;

  // --- Triggers: time on page, half the page read, or leaving (desktop) ---
  const inView = el => { if (!el) return false; const r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; };
  const busy = () => {
    const active = document.activeElement;
    if (active && active.matches('input,textarea,select,[contenteditable="true"]')) return true;
    if (document.querySelector('dialog[open], .o-ai.is-open, html.o-ai-lock')) return true;
    if ([...document.querySelectorAll('[aria-modal="true"]')].some(el => !el.hidden && el.getClientRects().length)) return true;
    if (getComputedStyle(document.documentElement).overflow === 'hidden' || getComputedStyle(document.body).overflow === 'hidden') return true;
    if (inView(document.getElementById('FooterOffer'))) return true; // the same offer is already on screen
    return false;
  };

  let fired = false;
  let seconds = 0;
  let lastScroll = 0;
  const timeLimit = isProduct ? 45 : phone.matches ? 25 : 35;
  const cleanup = new AbortController();
  const opts = { passive: true, signal: cleanup.signal };

  const fire = () => {
    if (fired) return;
    if (busy() || (phone.matches && Date.now() - lastScroll < 700)) { setTimeout(fire, phone.matches ? 800 : 4000); return; }
    fired = true;
    clearInterval(clock);
    cleanup.abort();
    showOffer();
  };

  const clock = setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    seconds += 1;
    if (seconds >= timeLimit) fire();
  }, 1000);

  addEventListener('scroll', () => {
    lastScroll = Date.now();
    if (fired || isProduct) return;
    const room = document.documentElement.scrollHeight - innerHeight;
    if (room < 500) return;
    const enoughTime = seconds >= (phone.matches ? 6 : 12);
    const deepEnough = scrollY / room >= 0.5 && scrollY > innerHeight;
    if (enoughTime && deepEnough) fire();
  }, opts);

  if (matchMedia('(hover: hover) and (pointer: fine)').matches && !phone.matches) {
    document.addEventListener('mouseout', event => {
      if (event.relatedTarget || event.clientY > 0 || seconds < 8) return;
      fire();
    }, opts);
  }
})();
